//设置语言
export function set_lang(state, lang) {
  state.epermarket_lang.locale = lang
}
// 改变语言参数
export function set_langType(state, langType, lang) {
  state.defaultParams.LanguageType = langType
  state.epermarket_lang.locale = lang
}
// 区域类型
export function set_areaType(state, Type) {
  state.defaultParams.AreaType = Type
}
// 城市id
export function set_CurrentCity(state, city) {
  state.defaultParams.CurrentCity = city
}
//用户token
export function set_UserToken(state, token) {
  state.defaultParams.Token = token
}
/*更新用户信息*/
export function set_user_info(state, res) {
  state.epermarket_user_info = res
}

// 设置购物车
export function setShopCar(state, res) {
  state.shopcarInfo = res
}
export function needShowCartToSeconds(state, val) {
  state.needShowCartToSeconds = val
}
// 设置会员id
export function set_PromWebFunctionID(state, val) {
  state.PromWebFunctionID = val
}

export function set_showMessage(state, msg) {
  state.MessageConfig.showMessage = true;
  setTimeout(()=>{
    state.MessageConfig.showMessage = false;
  },2000)
  state.MessageConfig.msg = msg;
}




// WEBPACK FOOTER //
// ./src/store/mutations.js